<template>
  <ul class="m-secNavi">
    <slot><li>メニューがありません</li></slot>
  </ul>
</template>

<script>
export default {
  computed: {
  },
  mounted () {
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getFamilies()
    })
  }
}
</script>

<style lang="scss" scoped>
.m-secNavi {
  list-style: none;
  margin: 0 0 0;
  padding: 0;
  width: 100%;
  border: 1px solid var(--color-border);
  /* border-radius: 5px; */
  font-size: .9rem;
}
</style>



// WEBPACK FOOTER //
// SecNavi.vue?24923fe4